<!--<particle-dynamic-transfer-box [filterId]="filterId"-->
<!--                               [invalidateSubject]="invalidateSubject"-->
<!--                               [leftSourceKey]="leftSourceKey"-->
<!--                               [rightSourceKey]="rightSourceKey">-->
<!--</particle-dynamic-transfer-box>-->
<div *ngIf="filterId && rightSourceType">
    <particle-entity-selector [filterId]="filterId"
                              [endpointName]="endpointName"
                              [filterTemplateId]="filterTemplateId"
                              [invalidateSubject]="invalidateSubject"
                              [rightSourceType]="rightSourceType"
                              [leftSourceType]="leftSourceType"
>
</particle-entity-selector>
</div>

